import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Up } from './Up';
export var FormUp = forwardRef(function (props, ref) { return (_jsx(Up, { ref: ref, size: "8px" })); });
//# sourceMappingURL=FormUp.js.map